import { apiClient } from '~/api/client';
import { AgentsData } from '~/sections/companies/profile/connections/types';

type IndexParams = {
  license: string;
  agent_type: string;
  period: Period;
};

type IndexResponse = {
  data: AgentsData;
};

export const index = async (allParams: IndexParams) => {
  const { license, ...params } = allParams;
  return apiClient.get<IndexResponse>(`/companies/${license}/realtors_stats`, { params });
};
